import React from 'react';
import { css } from '@corti/style';
import { useTheme } from '@corti/theme';
import { MenuItem, Typography } from 'lib/cortiUI';
export const Action = ({ title, onClick }) => {
    const theme = useTheme();
    return (React.createElement(MenuItem, { className: css({ padding: `${theme.space[3]}px ${theme.space[5]}px` }), onClick: onClick },
        React.createElement(Typography, { variant: "body2", color: "default" }, title)));
};
